// extracted by mini-css-extract-plugin
export default {"main_nav":"Navbar_main_nav__9b+oj","_logo":"Navbar__logo__8g8s5","row":"Navbar_row__Ojhps","_avatar":"Navbar__avatar__0C5Z2","name":"Navbar_name__L6emj"};